import React from 'react';
export default {
	checkmark: (
		<svg style={{ height: '68px', width: '68px' }} viewBox="0 0 24 24">
			<path
				fill="#ef5e41"
				d="M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4M11,16.5L6.5,12L7.91,10.59L11,13.67L16.59,8.09L18,9.5L11,16.5Z"
			/>
		</svg>
	),
	user: (
		<svg
			className="form-section__input-icons"
			style={{ height: '16px', width: '16px' }}
			viewBox="0 0 24 24">
			<path
				fill="#ef5e41"
				d="M12,13C9.33,13 4,14.33 4,17V20H20V17C20,14.33 14.67,13 12,13M12,4A4,4 0 0,0 8,8A4,4 0 0,0 12,12A4,4 0 0,0 16,8A4,4 0 0,0 12,4M12,14.9C14.97,14.9 18.1,16.36 18.1,17V18.1H5.9V17C5.9,16.36 9,14.9 12,14.9M12,5.9A2.1,2.1 0 0,1 14.1,8A2.1,2.1 0 0,1 12,10.1A2.1,2.1 0 0,1 9.9,8A2.1,2.1 0 0,1 12,5.9Z"
			/>
		</svg>
	),
	email: (
		<svg
			className="form-section__input-icons"
			style={{ height: '16px', width: '16px' }}
			viewBox="0 0 24 24">
			<path
				fill="#ef5e41"
				d="M4,4H20A2,2 0 0,1 22,6V18A2,2 0 0,1 20,20H4C2.89,20 2,19.1 2,18V6C2,4.89 2.89,4 4,4M12,11L20,6H4L12,11M4,18H20V8.37L12,13.36L4,8.37V18Z"
			/>
		</svg>
	),
	phone: (
		<svg
			className="form-section__input-icons"
			style={{ height: '16px', width: '16px' }}
			viewBox="0 0 24 24">
			<path
				fill="#ef5e41"
				d="M6.62,10.79C8.06,13.62 10.38,15.94 13.21,17.38L15.41,15.18C15.69,14.9 16.08,14.82 16.43,14.93C17.55,15.3 18.75,15.5 20,15.5A1,1 0 0,1 21,16.5V20A1,1 0 0,1 20,21A17,17 0 0,1 3,4A1,1 0 0,1 4,3H7.5A1,1 0 0,1 8.5,4C8.5,5.25 8.7,6.45 9.07,7.57C9.18,7.92 9.1,8.31 8.82,8.59L6.62,10.79Z"
			/>
		</svg>
	)
};



// WEBPACK FOOTER //
// ./src/components/form/SvgIcons.js